var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "clearfix" }, [
    _c(
      "div",
      {
        ref: "engineerSubmissionModal",
        staticClass: "reveal preview-submission-modal",
        attrs: { id: "engineerSubmissionModal", "data-reveal": "" },
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "tender-confirm clearfix" },
          [
            _c("div", { staticClass: "submission-email-subject" }, [
              _c("label", [_vm._v(_vm._s(_vm.$t("eCircular.subject")))]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t("tenantProjects.submission.submissionTitle", [
                      Number(_vm.displayBatchIndex) + 1,
                      _vm.currentTenantProject.projectName,
                    ])
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.canSend
              ? _c("div", { staticClass: "receivers-view-list" }, [
                  _c("div", { staticClass: "text-input" }, [
                    _c("label", { staticClass: "required-flag" }, [
                      _vm._v(_vm._s(_vm.$t("to"))),
                    ]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        { name: "hkldinput", rawName: "v-hkldinput" },
                        { name: "autosize", rawName: "v-autosize" },
                        {
                          name: "fusioninputcheck",
                          rawName: "v-fusioninputcheck",
                          value: {
                            type: "string",
                            tip: _vm.invalidEmailTip,
                            pattern: _vm.validateEmails,
                            classes: "tooltip-class",
                            required: true,
                          },
                          expression:
                            "{\n              type: 'string',\n              tip: invalidEmailTip,\n              pattern: validateEmails,\n              classes: 'tooltip-class',\n              required: true\n            }",
                        },
                      ],
                      staticClass: "autosize",
                      attrs: { required: true },
                      domProps: { value: _vm.displayTo },
                      on: {
                        input: function (event) {
                          return _vm.updateEmails(event, "to")
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-input" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("cc")))]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        { name: "hkldinput", rawName: "v-hkldinput" },
                        { name: "autosize", rawName: "v-autosize" },
                        {
                          name: "fusioninputcheck",
                          rawName: "v-fusioninputcheck",
                          value: {
                            type: "string",
                            tip: _vm.invalidEmailTip,
                            pattern: _vm.validateEmails,
                            classes: "tooltip-class",
                            required: _vm.cc.trim(),
                          },
                          expression:
                            "{\n              type: 'string',\n              tip: invalidEmailTip,\n              pattern: validateEmails,\n              classes: 'tooltip-class',\n              required: cc.trim()\n            }",
                        },
                      ],
                      staticClass: "autosize",
                      attrs: { required: _vm.cc.trim() },
                      domProps: { value: _vm.displayCC },
                      on: {
                        input: function (event) {
                          return _vm.updateEmails(event, "cc")
                        },
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-input" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("bcc")))]),
                    _vm._v(" "),
                    _c("textarea", {
                      directives: [
                        { name: "hkldinput", rawName: "v-hkldinput" },
                        { name: "autosize", rawName: "v-autosize" },
                        {
                          name: "fusioninputcheck",
                          rawName: "v-fusioninputcheck",
                          value: {
                            type: "string",
                            tip: _vm.invalidEmailTip,
                            pattern: _vm.validateEmails,
                            classes: "tooltip-class",
                            required: _vm.bcc.trim(),
                          },
                          expression:
                            "{\n              type: 'string',\n              tip: invalidEmailTip,\n              pattern: validateEmails,\n              classes: 'tooltip-class',\n              required: bcc.trim()\n            }",
                        },
                      ],
                      staticClass: "autosize",
                      attrs: { required: _vm.bcc.trim() },
                      domProps: { value: _vm.displayBCC },
                      on: {
                        input: function (event) {
                          return _vm.updateEmails(event, "bcc")
                        },
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "comments-preview-body-warpper" },
              [
                _c("CommentsPreviewBody", {
                  attrs: {
                    isBatchesView: false,
                    activeBatch: _vm.submissions[_vm.displayBatchIndex],
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("TenantSubmissionDocuments", {
              attrs: {
                files: _vm.files,
                sourceId:
                  (_vm.submissions[_vm.displayBatchIndex] || {}).id || "",
                canEdit: false,
              },
              on: {
                "update:files": function ($event) {
                  _vm.files = $event
                },
              },
            }),
            _vm._v(" "),
            _vm.canSend
              ? _c("div", { staticClass: "row align-right nav_btn" }, [
                  _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--darkblue",
                      attrs: { id: "confirm_no", type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.saveReceivers()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("action.save")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        { name: "hkldreset", rawName: "v-hkldreset" },
                      ],
                      staticClass: "btn btn--orange",
                      attrs: { id: "confirm_ok", type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.resend()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("tenantProjects.resendToTenant")))]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentTenantProject.type === _vm.tenantProjectTypes.Fitout &&
            !_vm.isDesignCommentFulfilled
              ? _c("div", { staticClass: "error-msg" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.designCommentsErrMsg) + "\n      "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "submission-send-history" }, [
              _c("div", { staticClass: "table-label" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("tenantProjects.sendHistory")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("table", { staticClass: "history-table" }, [
                _c("thead", [
                  _c(
                    "tr",
                    _vm._l(
                      _vm.sendHisotryTableHeaders,
                      function (header, index) {
                        return _c("th", { key: index, class: header.class }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(header.title) +
                              "\n              "
                          ),
                        ])
                      }
                    ),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.sendActionHistories, function (history, index) {
                    return _c("tr", { key: index }, [
                      _c("td", [
                        _vm._v(_vm._s(_vm.deep(history, "user.displayName"))),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm
                              .deep(history, "emailReceivers.to")
                              .replace(/;/g, "; ")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm
                              .deep(history, "emailReceivers.cc")
                              .replace(/;/g, "; ")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm
                              .deep(history, "emailReceivers.bcc")
                              .replace(/;/g, "; ")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "white-space": "nowrap" } }, [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm._f("capitalize")(
                                _vm._f("customStatusLabel")(
                                  _vm.deep(history, "actionType")
                                )
                              )
                            ) +
                            "\n              "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.dateUtil.formatDate(
                              _vm.deep(history, "updatedAt"),
                              true
                            )
                          )
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("CommentHistory", {
              attrs: { submission: _vm.submissions[_vm.displayBatchIndex] },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close-button",
        attrs: {
          "data-close": "",
          "aria-label": "Close modal",
          type: "button",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }